import { Component } from '@angular/core';

import { PortalsBaseComponent } from '../portals-base/portals-base.component';

@Component({
  standalone: true,
  imports: [PortalsBaseComponent],
  selector: 'app-portals-internal',
  template: `
    <app-portals-base
      [config]="{
        isExternal: false,
        domainSuffix: '.unthread.io',
        title: 'Internal Customer Portal',
        noPortalMessage: 'You don\\'t have an internal portal',
        noPortalDescription:
          'Create an internal portal to allow your employees to access & search knowledge bases and submit tickets.'
      }"
    ></app-portals-base>
  `,
})
export class PortalsInternalComponent {}
